<style lang="scss" scoped>
	.past-old {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	@media (min-width:800px) {
		.past-old {
			background: url('../../assets/past/pass-bg-pc.png') no-repeat center;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.contianer {
			position: relative;
			width: 742px;
			height: 742px;
		}
		.background {
			position: absolute;
			top: 0;
			left: 0;
			width: 742px;
			height: 742px;
			text-align: center;
			animation:animation1 40s linear infinite;
		}
		@keyframes animation1 {
			0%{ transform: rotate(0deg); }
			100%{ transform: rotate(360deg); }
		}
		.contianer .content {
			position: absolute;
			top: 0;
			bottom: 0;
			width: 100%;
			text-align: center;
			cursor: pointer;
			padding-top: 40%;
			.word1 {
				position: relative;
				display: inline-block;
				padding-left: 10px;
				padding-right: 10px;
				color: #b74669;
				font-weight: bold;
				margin-bottom: 10px;
				transition: all 3s linear;
				.word-bg1 {
					position: absolute;
					top: 0;
					left: 0;
				}
				.word-bg2 {
					position: absolute;
					right: 0;
					bottom: 0;
				}
			}
			.word2 {
				font-weight: bold;
				font-size: 22px;
				color: #bc7566;
			}
		}
		.contianer .content-bg {
			background: url('../../assets/past/circle-bg-other.png') no-repeat center;
		}
		.contianer .content .step4-content {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			margin: 0 auto;
			width: 648px;
			height: 648px;
			background: url("../../assets/past/step4-content-bg-other-pc.png") no-repeat center;
			overflow: hidden;
			.step4-content-bg {
				animation:animation2 40s linear infinite;
			}
			@keyframes animation2 {
				0%{ transform: rotate(0deg); }
				100%{ transform: rotate(360deg); }
			}
			.card {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				margin: 0 auto;
			}
			.word1 {
				position: absolute;
				left: 0;
				right: 0;
				margin: 0 auto;
				bottom: 50px;
    			width: 170px;
			}
			.word2 {
				position: absolute;
				left: 0;
				right: 0;
				margin: 0 auto;
				bottom: 0;
			}
		}
		.contianer .content .step-word-other {
			position: absolute;
			z-index: 100;
			top: 87px;
			left: 0;
		}
		.step1-size {
			font-size: 36px;
		}
		.step3-size {
			font-size: 22px;
		}
		.step3-size-other {
			font-size: 30px;
		}
		.step5-size {
			font-size: 26px;
		}
		.step6-size {
			font-size: 20px;
		}
		.image-list1 {
			position: absolute;
			top: 200px;
			left: -210px;
			width: 1200px;
			height: auto;
			overflow: auto;
			display: flex;
			justify-content: space-around;
		}
		.image-list2 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
		.image-list3 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
		.step8-word1 {
			width: 290px;
    		height: 35px;
		}
	}
	@media (max-width:800px) {
		.past-old {
			background: url('../../assets/past/pass-bg-mobile.png') no-repeat center;
			background-size: 100% 100%;
			padding-top: 20vh;
		}
		.contianer {
			position: relative;
		}
		.background {
			width: 100%;
			height: 100%;
			animation:animation1 40s linear infinite;
		}
		@keyframes animation1 {
			0%{ transform: rotate(0deg); }
			100%{ transform: rotate(360deg); }
		}
		.contianer .content {
			position: absolute;
			top: 0;
			bottom: 0;
			width: 100%;
			text-align: center;
			cursor: pointer;
			padding-top: 40%;
			.word1 {
				position: relative;
				display: inline-block;
				padding-left: 10px;
				padding-right: 10px;
				color: #b74669;
				font-weight: bold;
				margin-bottom: 10px;
				padding-top: 2px;
				padding-bottom: 2px;
				.word-bg1 {
					position: absolute;
					top: 0;
					left: 0;
					width: 18px;
				}
				.word-bg2 {
					position: absolute;
					right: 0;
					bottom: 0;
					width: 18px;
				}
			}
			.word2 {
				font-weight: bold;
				font-size: 16px;
				color: #bc7566;
			}
		}
		.contianer .content-bg {
			background: url('../../assets/past/circle-bg-other.png') no-repeat center;
			background-size: 82% 72%;
		}
		.contianer .content .step4-content {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			margin: 0 auto;
			width: 375px;
			height: auto;
			background: url("../../assets/past/step4-content-bg-other-pc.png") no-repeat center;
			background-size: 375px 375px;
			overflow: hidden;
			.step4-content-bg {
				width: 120%;
				height: 120%;
				position: relative;
				left: -10%;
				top: -10%;
				animation:animation2 40s linear infinite;
			}
			@keyframes animation2 {
				0%{ transform: rotate(0deg); }
				100%{ transform: rotate(360deg); }
			}
			.card {
				position: absolute;
				top: 8%;
				left: 0;
				right: 0;
				margin: 0 auto;
				width: 67%;
			}
			.word1 {
				position: absolute;
				left: 0;
				right: 0;
				margin: 0 auto;
				bottom: 35px;
				width: 125px;
				font-size: 18px;
			}
			.word2 {
				position: absolute;
				left: 0;
				right: 0;
				margin: 0 auto;
				bottom: 0;
			}
		}
		.contianer .content .step-word-other {
			position: absolute;
			top: 20px;
			left: 0;
			right: 0;
			margin: 0 auto;
		}
		.step1-size {
			font-size: 22px;
		}
		.step3-size {
			font-size: 16px;
		}
		.step3-size-other {
			font-size: 20px;
		}
		.step5-size {
			font-size: 20px;
		}
		.step6-size {
			font-size: 14px;
		}
		.image-list1 {
			position: absolute;
			top: 12vh;
			width: 100%;
			height: auto;
			overflow: auto;
			text-align: center;
			.image-item {
				width: 26%;
				margin-left: 6%;
				margin-right: 2%;
				&:nth-child(5) {
					position: absolute;
					left: 0;
					right: 0;
					top: 17vh;
					margin: 0 auto;
				}
			}
		}
		.image-list2 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
		.image-list3 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
		.step8-word1 {
			width: 215px;
    		height: 25px;
		}
	}
	.slide-fade-enter-active {
		transition: all 2s ease;
	}
	.slide-fade-enter {
		opacity: 0;
	}
	.slide-fade1-enter-active {
		transition: all 1.5s ease;
	}
	.slide-fade1-enter {
		transform: translateX(30px);
		opacity: 0;
	}
	.slide-fade2-enter-active {
		transition: all 4s ease;
	}
	.slide-fade2-enter {
		opacity: 0;
	}
	.bounce-enter-active {
		animation: bounce-in 2s 0.5;
	}
	@keyframes bounce-in {
		0% {transform: scale(0);}
		50% {transform: scale(1.4);}
		100% {transform: scale(1);}
	}
</style>

<template>
	<div class="past-old">
		<div class="contianer">
			<img v-show="(currentStepNumber!='4' && currentStepNumber!='6') || !afterShow" class="background" src="../../assets/past/circle-bg.png" alt="background">
			<div 
				:class="['content', {'content-bg': (currentStepNumber!='4'&& currentStepNumber!='6') || !afterShow}]" 
				@click="goStep" 
			>
				<!-- 第一步 -->
				<transition name="slide-fade">
					<div v-if="currentStepNumber == '1'" class="step1">
						<div class="word1">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step1-size">別來無恙？{{accountInfo.name}}</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="word2">跨過歲月，與你再度相見</div>
						</transition>
					</div>
				</transition>
				<!-- 第二步 -->
				<transition name="slide-fade">
					<div v-if="currentStepNumber == '2'" class="step2">
						<div class="word1">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step1-size">還記得我們初次相遇嗎？</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="word2">
								<transition name="bounce">
									<div v-show="afterShow" style="display: inline-block;">{{accountInfo.cts}}</div>
								</transition>
								<span>，我們一起踏上旅途</span>
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第三步 -->
				<transition name="slide-fade">
					<div v-if="currentStepNumber == '3'" class="step3">
						<div class="word1">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step3-size" style="">還記得你在這個世界遇到了多少夥伴嗎？</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="word2">
								<transition name="bounce">
									<div v-show="afterShow" style="display: inline-block;" class="step3-size-other">{{accountInfo.count}}</div>
								</transition>
								<span style="position: relative; left: 5px; top: -2px;">個</span>
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第四步 -->
				<transition name="slide-fade">
					<div v-if="currentStepNumber == '4'" class="step4">
						<div v-show="!afterShow" class="word1">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step3-size">那個在你跌跌撞撞時一直陪伴的他，還好嗎？</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="step4-content">
								<img class="step4-content-bg" src="../../assets/past/step4-content-bg-pc.png" alt="">
								<img class="card" :src="accountInfo.dreamguy" alt="card">
								<transition name="slide-fade1">
									<div v-show="step4CardWordShow" class="word1">
										<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
										<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
										<span class="step1-size">是他吧？</span>
									</div>
								</transition>
								<transition name="slide-fade1">
									<div v-show="step4CardWordShow" class="word2">一直在你身邊，不離不棄——他很想你</div>
								</transition>
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第六步 -->
				<transition name="slide-fade">
					<div v-if="currentStepNumber == '5'" class="step6">
						<div :class="['word1', {'step-word-other': afterShow}]">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step6-size">
								<span>還記得那些與你並肩作戰的夥伴嗎？</span><br>
								<span>這個世界潛藏著許多危險，但他們一定會護你周全</span>
							</span>
						</div>
						<transition name="slide-fade2">
							<div v-show="afterShow" class="image-list1">
								<img v-for="(item, index) in zdhb" :key="index" :src="item" :alt="item" class="image-item">
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第七步 -->
				<transition name="slide-fade">
					<div v-if="currentStepNumber == '6'" class="step7">
						<div v-show="!afterShow" :class="['word1', {'step-word-other': afterShow}]">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step6-size">
								<span>為了你，這個世界一直在改變，</span><br>
								<span>原來我們已經攜手走了這麼遠的路了</span>
							</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="image-list2">
								<video 
									style="width: 100%; height: auto;"
									autoplay 
									muted="true" 
									x5-video-player-type='h5' 
									x5-video-player-fullscreen='true' 
									webkit-playsinline 
									playsinline
									:src="step7Video"
								></video>
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第八步 -->
				<transition name="slide-fade">
					<div v-if="currentStepNumber == '7'" class="step8">
						<div class="word1 step8-word1">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step6-size">
								<span>時光荏苒</span>
								<transition name="slide-fade">
									<span v-show="afterShow">，轉眼間已一年有餘</span>
								</transition>
							</span>
						</div>
					</div>
				</transition>
				<!-- 第九步 -->
				<transition name="slide-fade">
					<div v-if="currentStepNumber == '8'" class="step9">
						<div v-show="!afterShow" :class="['word1', {'step-word-other': afterShow}]">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step6-size">
								<span>這個世界不會停止轉動，它將和你一起變得更美好</span><br>
								<span>為了能夠迎接你的回歸，這個世界會一直變得更美好</span><br>
							</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="image-list3">
								<video 
									style="width: 100%; height: auto;"
									autoplay 
									muted="true" 
									x5-video-player-type='h5' 
									x5-video-player-fullscreen='true' 
									webkit-playsinline 
									playsinline 
									:src="step9Video"
								></video>
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第十步 -->
				<transition name="slide-fade">
					<div v-if="currentStepNumber == '9'" class="step10">
						<div class="word1">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step3-size-other">
								<span>感謝你一路陪伴</span>
							</span>
						</div>
						<div class="word2">结束</div>
					</div>
				</transition>
			</div>
		</div>
		<!-- 背景音乐 -->
		<audio 
			autoplay 
			loop="loop"
			:src="voicePath" 
			id="bg_voice"
		>您的浏览器不支持 audio 标签。</audio>
	</div>
</template>

<script>
export default {
	name: 'past-new',
	data() {
		return {
			voicePath: require('../../assets/background-voice.mp3'),
			account: '',
			type: 1,
			currentStepNumber: '1',
			interValRoot: null,
			interValTime: 20000,
			afterShow: false,
			accountInfo: {
				cts: "",
				dreamguy: "",
				name: '',
				count: 0
			},
			XTime: '',
			zdhb: [],
			huiyi: [],
			xinneirong: [],
			step7Video: 'http://fbbsoc-download.joymore.cn/brotherland/website/phone-video.mp4',
			step9Video: 'http://fbbsoc-download.joymore.cn/brotherland/website/past-p-video1.mp4',
			step4CardWordShow: false,
			timeOutRoot: null
		}
	},
	watch: {
		currentStepNumber() {
			this.afterShow = false;
			this.showAfter();
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width < 850) {
			this.step7Video = 'http://fbbsoc-download.joymore.cn/brotherland/website/past-old-m-video1.mp4';
			this.step9Video = 'http://fbbsoc-download.joymore.cn/brotherland/website/past-m-video1.mp4';
		}

		this.account = this.$route.query.account;
		console.log(this.account);
		this.initData();
	},
	methods: {
		initData() {
			this.$http.get('/api/subscribe/getAccountInfoOldFan?code=' + this.account).then(res => {
				this.accountInfo = res.result.accountInfo;
				this.XTime = res.result.XTime;
				this.zdhb = res.result.zdhb;
				this.huiyi = res.result.huiyi;
				this.xinneirong = res.result.xinneirong;
				this.interVal();
				this.showAfter();
			});
		},
		interVal() {
			this.interValRoot = setInterval(() => {
				if(this.currentStepNumber == '9') {
					this.clearInterVal();
				} else {
					this.currentStepNumber = Number(this.currentStepNumber) + 1 + '';
					if(this.currentStepNumber == "6" || this.currentStepNumber == "8") {
						this.clearInterVal();
						this.interValTime = 30000;
						this.interVal();
					} else {
						if(this.interValTime != 20000) {
							this.clearInterVal();
							this.interValTime = 20000;
							this.interVal();
						}
					}
				}
			}, this.interValTime);
		},
		clearInterVal() {
			clearInterval(this.interValRoot);
		},
		showAfter() {
			this.timeOutRoot = setTimeout(() => {
				this.afterShow = true;
				if(this.currentStepNumber == '4') {
					this.step4CardWordShow = true;
				}
				clearTimeout(this.timeOutRoot);
			}, 10000);
		},
		goStep() {
			if(!this.afterShow) {
				this.afterShow = true;
				clearTimeout(this.timeOutRoot);
			} else {
				if(this.currentStepNumber == '4') {
					if(!this.step4CardWordShow) {
						this.step4CardWordShow = true;
					} else {
						if(Number(this.currentStepNumber) <= 8) {
							this.currentStepNumber = Number(this.currentStepNumber) + 1 + '';
						}
					}
				} else {
					if(Number(this.currentStepNumber) <= 8) {
						this.currentStepNumber = Number(this.currentStepNumber) + 1 + '';
					}
				}
			}
			this.clearInterVal();
		},
		goAppoint() {
			const width = document.body.clientWidth;
			if(width > 850) {
				this.$router.push({name: 'appoint-home-pc'});
			} else {
				this.$router.push({name: 'appoint-home-mobile'});
			}
		},
		goWebsite() {
			const width = document.body.clientWidth;
			if(width > 850) {
				this.$router.push({name: 'p-index'});
			} else {
				this.$router.push({name: 'm-index'});
			}
		}
	},
	beforeDestroy() {
		this.clearInterVal();
		clearTimeout(this.timeOutRoot);
	}
}
</script>